<template>
    <div>
        <el-form ref="formRef" :model="form" label-width="150px" :rules="rules">
            <el-form-item label="分类" prop="categoryName">
                <el-input v-model="form.categoryName"></el-input>
            </el-form-item>
            <el-form-item label="标题/名称" prop="title">
                <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.title">
                </el-input>
            </el-form-item>
            <el-form-item label="内容" prop="content">
                <editor v-model="form.content"></editor>
            </el-form-item>
            <el-form-item label="图片" prop="image">
                <div style="display: flex;">
                    <el-upload class="upload-demo" :action="this.uploadURL" style="text-align: left" :on-success="(response, file, fileList) =>
                        handleAvatarSuccess(response, file, fileList, 'file')
                        " accept=".png,.jpg,.jpeg,.gif,.bmp,.tif,.tiff" :limit="1" :on-remove="handleRemove">
                        <el-button size="small" type="primary" style="margin-top: 10px;">上传图片</el-button>
                    </el-upload>
                    <el-image style="width: 40px;height: 40px;margin-top: 6px;margin-left: 5px;"
                        :src="imgUrl + form.image" :preview-src-list="[imgUrl + form.image]" />
                </div>
            </el-form-item>
            <el-form-item label="添加日期" prop="createTime">
                <el-date-picker format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" disabled v-model="form.createTime" type="datetime"
                    placeholder="选择日期时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="是否显示" prop="isShow">
                <el-checkbox v-model="form.isShow">备选项</el-checkbox>
            </el-form-item>
            <el-form-item style="display: flex;justify-content: center;margin-left: -150px;">
                <el-button type="primary" @click="onSubmit">修 改</el-button>
                <el-button @click="resetForm">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import editor from '../../../components/tinymce-editor/tinymce-editor';
export default {
    components: {
        editor
    },
    data() {
        return {
            form: {
                categoryName: '',
                title: '',
                content: '',
                image: '',
                createTime: '',
                isShow: true,
                id: ''
            },
            rules: {
                title: [
                    { required: true, message: '请输入名称', trigger: 'blur' }
                ],
                createTime: [
                    { required: true, message: '请选择添加日期', trigger: 'blur' }
                ],
            }
        }
    },
    methods: {
        onSubmit() {
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    let params = {
                        ...this.form,
                    }
                    params.isShow = params.isShow ? 1 : 0;
                    this.http.put('apij2/admin-api/voucher/large-screen-technology-market-management/update', params).then((res) => {
                        if (res.data) {
                            this.resetForm()
                            this.$message({
                                message: '编辑成功',
                                type: 'success'
                            });
                        } else {
                            this.$message({
                                message: '请检查表单内容',
                                type: 'warning'
                            });
                        }

                    });
                } else {
                    this.$message({
                        message: '请检查表单内容',
                        type: 'warning'
                    });
                }
            })

        },
        onClose() {
            this.$emit('onClose')
        },
        resetForm() {
            this.$emit('onSubmit')
            this.$refs.formRef.resetFields();
        },
        getData(row) {
            this.form = { ...row }
            this.form.isShow = this.form.isShow === 1 ? true : false;
        },
        //上传文件事件
        handleAvatarSuccess(response, file, fileList, type) {
            this.form.image = response.data.store_result;
        },
        handleRemove() {
            this.form.image = '';
        },
    }
}   
</script>
<style scoped lang="scss">
span {
    color: #868686;
    font-size: 12px;
}

/deep/.upload-demo {
    border: none !important;
}
</style>